<div id="myModal" data-backdrop="static" data-keyboard="false">
  <!-- <div class="modal-header"  style="background-color: white !important; widows: 50px !important">
              <h4 class="modal-title" style="margin-top: -2px;">{{type}}</h4>
              <i
                aria-hidden="true"
                style="cursor:pointer;padding-right:6px;padding-top:5px;"
                class="bento-icon-close-x"
                (click)="activeModal.dismiss('Cross click')"
              >
              </i>
            </div> -->
  <div class="container row" style="margin-right: 0px !important; margin-left: 0px !important;">
    <div *ngIf="isConfirmModal">
      <div class="col-md-14 confirmDiv">
        <i aria-hidden="true" class="bento-icon-warning confirmIcon">
        </i>
        <p class="confirmMessage">{{message}}</p>
      </div>
    </div>
    <div *ngIf="isAlert">
      <div class="col-md-14 alertDiv">
        <i aria-hidden="true" class="bento-icon-info alertIcon">
        </i>
        <p class="alertMessage">{{message}}</p>
      </div>
    </div>
    <div *ngIf="isAlertSuccess">
      <div class="col-md-14 alertDiv">
        <i aria-hidden="true" class="bento-icon-confirm alertIconSuccess">
        </i>
        <p class="alertMessageSuccess">{{message}}</p>
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <div class="footerButtonsDiv">
      <button *ngIf="isConfirmModal||isAlert||success" type="button" class="btn btn-primary okButton"
        (click)="confirm()">{{okButtonCaption}}</button>
      <button id="close" *ngIf="isConfirmModal" type="button" class="btn btn-outline-primary"
        (click)="activeModal.dismiss('Cross click')">{{cancelButtonCaption}}</button>
      <button *ngIf="isAlertSuccess" type="button" class="btn btn-primary okButtonSuccess"
        (click)="confirm()">{{okButtonCaption}}</button>
    </div>
  </div>
</div>
